<template>
  <td v-if="renderCell" :class="className">
    <div class="w-full h-full flex flex-row gap-2 items-center">
      <base-button-icon
        class="action-button"
        v-for="action in value"
        :key="action[actionIdField]"
        :id="action[actionIdField]"
        :name="action[actionIconField]"
        size="xs" icon-size="xsm"
        @click.stop="onClickAction"
      />
    </div>
  </td>
  <td v-else-if="renderArrow" :key="'g' + columnIndex" :class="'k-group-cell'" />
  <td v-else-if="columnIndex <= level" key='g-colspan' :colSpan="columnsCount - columnIndex">
    <p class='k-reset'>
      <a @click="onGroupClick" tabIndex='-1' href='#' :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'" />
      {{ groupHeader }}
    </p>
  </td>
</template>
<script>
import { i18n } from '@/i18n'

export default {
  name: 'actions-template',
  emits: {
    click: null
  },
  props: {
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {}
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      // return returnValue && this.dataItem[this.field]
      return returnValue && this.dataItem[this.field] !== undefined
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    value: function () {
      return this.extraparams?.actions ?? []
    },
    groupHeader () {
      return ''
    },
    actionIdField: function () {
      return this.extraparams?.actionId ?? 'idAccion'
    },
    actionIconField: function () {
      return this.extraparams?.actionIcon ?? 'icon'
    },
  },
  methods: {
    onClick (e) {
      // @ts-ignore
      this.$emit('click', e, this.dataItem, this.expanded)
    },
    onGroupClick (e) {
      // @ts-ignore
      this.$emit('groupclick', e, this.dataItem, this.expanded)
    },
    onClickAction (e) {
      const idAccion = e.target.closest('.action-button').id
      const dataItem = this.dataItem
      const action = this.value.find(x => x[this.actionIdField]?.toString() === idAccion)
      if (action) {
        this.$emit('actionclick', { dataItem, action })
      } else {
        console.error(i18n.t('feedback.error.unexpected_action_error', { action: idAccion }))
      }
    }
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
</style>
